export default "/_next/static/assets/download-google_1d492c2d197e0b7e14fe6775fe5b9567.png";